export const SITE_GALLERY_VIEW_FRENCH_LOCALE = {
  gallery: "Galerie",
  emptyTitle: "Aucune photo",
  emptyDetails: "Aucune photo n'est disponible sur le site pour le moment",
};
